/* ============================================================
   FRAISE NOIRE — COUCHE CINÉTIQUE (le peu de JS qui reste)
   ------------------------------------------------------------
   Presque tout le mouvement du site est fait en CSS natif
   (css/cinetique.css). Ce fichier ne garde que les trois choses
   qu'une feuille de style ne peut pas faire seule :

     1. poser le fil de lecture en haut de l'écran ;
     2. le magnétisme des boutons (il faut la position du curseur) ;
     3. faire voyager la photo d'une page à l'autre pendant la
        transition de navigation (il faut savoir OÙ on a cliqué).

   Aucune dépendance. ~2 Ko. Se désactive de lui-même si
   l'utilisateur a demandé moins d'animations.
   ============================================================ */
(() => {
  'use strict';

  /* ---------------------------------------------------------
     0 · LE FILET DE SECURITE DE L'ECRAN D'OUVERTURE
     ---------------------------------------------------------
     `.ouv` est un voile BLANC en plein ecran, z-index 2000, qui
     recouvre entierement le site. Il n'etait retire que par une
     animation CSS (`ouv-retirer`, 0,62 s apres 1,12 s de delai)
     et par RIEN d'autre.

     Si cette animation ne joue pas — un navigateur qui la gere
     autrement, un onglet ouvert en arriere-plan, une feuille de
     style qui arrive trop tard — le voile reste et le site
     devient une page blanche. Aucun element qui masque la
     totalite d'une page ne doit dependre d'une seule animation.

     On le retire donc aussi par le code, apres un delai large :
     si l'animation a fait son travail, ce retrait ne change
     rien ; sinon, il sauve la page.
     --------------------------------------------------------- */
  (() => {
    const ouv = document.querySelector('.ouv');
    if (!ouv) return;
    const retirer = () => {
      ouv.style.display = 'none';
      ouv.setAttribute('aria-hidden', 'true');
    };
    // apres la fin theorique de l'animation (1,12 s + 0,62 s), avec de la marge
    setTimeout(retirer, 2600);
    // et des que l'animation se termine normalement
    ouv.addEventListener('animationend', retirer, { once: true });
    // un onglet ouvert en arriere-plan ne joue pas ses animations :
    // on rattrape au retour
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) setTimeout(retirer, 1800);
    }, { once: true });
  })();

  const sobre = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const tactile = matchMedia('(hover: none)').matches;

  /* ---------------------------------------------------------
     1 · LE FIL DE LECTURE
     Un simple élément ; c'est le CSS qui le remplit au scroll.
     --------------------------------------------------------- */
  if (!sobre && !document.querySelector('.cin-fil')) {
    const fil = document.createElement('div');
    fil.className = 'cin-fil';
    fil.setAttribute('aria-hidden', 'true');
    document.body.appendChild(fil);
  }

  /* ---------------------------------------------------------
     2 · LE MAGNÉTISME
     Le bouton se décale de quelques pixels vers le curseur, puis
     revient. On ne touche jamais à `transform` (réservé aux
     survols existants) : on écrit deux variables CSS.
     --------------------------------------------------------- */
  if (!sobre && !tactile) {
    const FORCE = 0.28;      // fraction du déplacement du curseur
    const MAX = 9;           // jamais plus de 9 px : c'est une sensation, pas un jeu

    const cibles = document.querySelectorAll('.btn--solid, .cin-aimant, .news__btn');
    cibles.forEach(el => {
      el.classList.add('cin-aimant');

      el.addEventListener('pointerenter', () => el.classList.add('cin-tient'));
      el.addEventListener('pointermove', e => {
        const r = el.getBoundingClientRect();
        const dx = (e.clientX - (r.left + r.width / 2)) * FORCE;
        const dy = (e.clientY - (r.top + r.height / 2)) * FORCE;
        el.style.setProperty('--cin-x', Math.max(-MAX, Math.min(MAX, dx)).toFixed(1) + 'px');
        el.style.setProperty('--cin-y', Math.max(-MAX, Math.min(MAX, dy)).toFixed(1) + 'px');
      });
      el.addEventListener('pointerleave', () => {
        el.classList.remove('cin-tient');
        el.style.setProperty('--cin-x', '0px');
        el.style.setProperty('--cin-y', '0px');
      });
    });
  }

  /* ---------------------------------------------------------
     3 · LA PHOTO QUI VOYAGE
     Au clic sur une pièce, on nomme son image « piece ». Sur la
     fiche qui s'ouvre, l'image principale porte le même nom : le
     navigateur comprend que c'est le MÊME objet et le déplace au
     lieu de faire un fondu. Le nom doit être unique dans la page,
     d'où le nettoyage systématique avant de le poser.
     --------------------------------------------------------- */
  const NOM = 'piece';

  function nommer(el) {
    if (!el) return;
    document.querySelectorAll('[style*="view-transition-name"]').forEach(x => {
      x.style.viewTransitionName = '';
    });
    el.style.viewTransitionName = NOM;
  }

  if (!sobre && CSS.supports('view-transition-name', 'x')) {

    // départ : la carte produit sur laquelle on clique
    document.addEventListener('click', e => {
      const lien = e.target.closest('.card__link, .gapitem__media, .mz-craft a, .fsearch__item');
      if (!lien) return;
      const img = lien.querySelector('img') || lien.closest('.card')?.querySelector('.card__img--front');
      nommer(img);
    }, true);   // en capture : on passe avant les autres gestionnaires

    // arrivée : l'image principale de la fiche produit
    if (location.pathname.endsWith('/products/')) {
      const poser = () => {
        const img = document.querySelector('.pdp__gallery .pdp__shot img');
        if (img) { nommer(img); return true; }
        return false;
      };
      if (!poser()) {
        // la galerie est rendue par produit.js : on attend son apparition
        const obs = new MutationObserver(() => { if (poser()) obs.disconnect(); });
        obs.observe(document.body, { childList: true, subtree: true });
        setTimeout(() => obs.disconnect(), 4000);
      }
    }

    // retour arrière : on repart d'une page propre
    window.addEventListener('pageswap', () => {
      document.querySelectorAll('[style*="view-transition-name"]').forEach(x => {
        x.style.viewTransitionName = '';
      });
    });
  }
})();
